import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconSupermarket$1 = /*@__PURE__*/ proxyCustomElement(class WppIconSupermarket extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-supermarket", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.50003 2C5.31346 2 5.13358 2.06954 4.99553 2.19504L2.24553 4.69504C2.08609 4.83999 2.00005 5.04295 2 5.2502V7.08336C2 7.60615 2.15067 8.37365 2.62468 9.032C2.79474 9.26819 3.00248 9.48424 3.25 9.66666V17.25C3.25 17.6642 3.58579 18 4 18H16C16.4142 18 16.75 17.6642 16.75 17.25V9.66668C16.9976 9.48425 17.2053 9.26818 17.3754 9.03196C17.8494 8.37361 18.0001 7.60611 18.0001 7.08332L18.0001 5.25C18 5.04274 17.914 4.83999 17.7545 4.69504L15.0045 2.19504C14.8665 2.06954 14.6866 2 14.5 2H5.50003ZM4.75 16.5V10.2284C4.88353 10.2426 5.02239 10.25 5.16667 10.25C6.28186 10.25 7.07335 9.80792 7.58329 9.19404C8.09324 9.80792 8.88473 10.25 9.99992 10.25C11.1152 10.25 11.9067 9.80784 12.4167 9.19387C12.9266 9.80782 13.7181 10.25 14.8334 10.25C14.9777 10.25 15.1165 10.2426 15.25 10.2284V16.5H13.25V14.5C13.25 12.7051 11.7949 11.25 10 11.25C8.20507 11.25 6.75 12.7051 6.75 14.5V16.5H4.75ZM8.25 16.5H11.75V14.5C11.75 13.5335 10.9665 12.75 10 12.75C9.0335 12.75 8.25 13.5335 8.25 14.5V16.5ZM16.5001 6H13.1667V7.08332C13.1667 7.36608 13.2577 7.80691 13.5087 8.15551C13.7322 8.46586 14.1112 8.74998 14.8334 8.74998C15.5556 8.74998 15.9346 8.46586 16.1581 8.15551C16.4091 7.80691 16.5001 7.36608 16.5001 7.08332V6ZM3.5 7.08336V6H6.83325V7.08336L6.83328 7.09545C6.83073 7.37857 6.73879 7.81188 6.49135 8.15555C6.2679 8.4659 5.88889 8.75002 5.16667 8.75002C4.44444 8.75002 4.06544 8.4659 3.84198 8.15555C3.591 7.80695 3.5 7.36612 3.5 7.08336ZM8.33333 7.08336L8.33331 7.09545C8.33586 7.37857 8.4278 7.81188 8.67524 8.15555C8.89869 8.4659 9.27769 8.75002 9.99992 8.75002C10.7221 8.75002 11.1011 8.4659 11.3246 8.15555C11.5756 7.80695 11.6666 7.36612 11.6666 7.08336V6H8.33333V7.08336ZM4.68999 4.5L5.78999 3.5H14.2101L15.3101 4.5H4.68999Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-supermarket-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-supermarket", "wpp-icon-supermarket-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-supermarket-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-supermarket-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconSupermarket$1);
      }
      break;
  } });
}

const WppIconSupermarket = WppIconSupermarket$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconSupermarket, defineCustomElement };
